module.exports = __webpack_public_path__ + "static/media/solastalgia-8.871f1aee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/solastalgia/solastalgia-8.jpg
// module id = 4433
// module chunks = 15